import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=747c6c04&scoped=true&lang=html&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c6c04",
  null
  
)

export default component.exports